<div class="controls-wrap">
  <!-- Delete -->
  <button class="ctrl-btn ctrl-btn--danger"
    [disabled]="deleteDisabled"
    [matTooltip]="deleteDisabledToolTip"
    (click)="deleteAds()">
    <mat-icon>delete_outline</mat-icon>
    <span>{{ 'sale4you.label.ads.delete' | translate }}</span>
  </button>

  <!-- Pause (shown when active). SCRUM-177: not for ads still in review -
       pausing and then resuming used to let an owner publish an ad that no
       admin had approved. -->
  @if (adsItem.statusAds === StatusAds.Active) {
    <button
      class="ctrl-btn ctrl-btn--warning"
      [disabled]="resumeDisabled"
      [matTooltip]="resumeDisabledToolTip"
      (click)="pauseAds()">
      <mat-icon>pause_circle_outline</mat-icon>
      <span>{{ 'sale4you.label.ads.resume' | translate }}</span>
    </button>
  }

  <!-- Play (shown when paused) -->
  @if (adsItem.statusAds === StatusAds.Pause) {
    <button
      class="ctrl-btn ctrl-btn--success"
      [disabled]="playDisabled"
      [matTooltip]="playDisabledToolTip"
      (click)="playAds()">
      <mat-icon>play_circle_outline</mat-icon>
      <span>{{ 'sale4you.label.ads.play' | translate }}</span>
    </button>
  }

  <!-- SCRUM-144: no "Edit" (עריכה) button here - the ad's details are not
       editable from "My ads". -->

  <!-- Mark as done -->
  <button class="ctrl-btn ctrl-btn--success"
    [disabled]="payDisabled"
    [matTooltip]="payDisabledToolTip"
    (click)="doneAds()">
    <mat-icon>check_circle_outline</mat-icon>
    <span>{{ 'sale4you.label.ads.pay' | translate }}</span>
  </button>

  <!-- Admin: block -->
  @if (isAdminUser && adsItem.statusAds !== StatusAds.Blocked) {
    <button
      class="ctrl-btn ctrl-btn--danger"
      [disabled]="blockDisabled"
      [matTooltip]="resumeDisabledToolTip"
      (click)="blockAds()">
      <mat-icon>block</mat-icon>
      <span>{{ 'sale4you.label.ads.block' | translate }}</span>
    </button>
  }

  <!-- Admin: unblock -->
  @if (isAdminUser && adsItem.statusAds === StatusAds.Blocked) {
    <button
      class="ctrl-btn ctrl-btn--success"
      [disabled]="blockDisabled"
      [matTooltip]="playDisabledToolTip"
      (click)="playAds()">
      <mat-icon>play_circle_outline</mat-icon>
      <span>{{ 'sale4you.label.ads.play' | translate }}</span>
    </button>
  }

  <!-- Admin: approve -->
  @if (isAdminUser) {
    <button
      class="ctrl-btn ctrl-btn--primary"
      [disabled]="approveDisabled"
      [matTooltip]="playDisabledToolTip"
      (click)="playAds()">
      <mat-icon>verified_outlined</mat-icon>
      <span>{{ 'sale4you.label.ads.active' | translate }}</span>
    </button>
  }
</div>
